
// export default RecentUploads;
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SideBar from "../Includes/Sidebar";
import { toast } from "react-toastify";

// const caseData = {
//   message: [
//     {
//       case_id: 7,
//       case_name: "email testing",
//       page_count: 25,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-10T07:32:44",
//     },
//     {
//       case_id: 8,
//       case_name: "Symora Harris Bolden",
//       page_count: 273,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-10T11:40:48",
//     },
//     {
//       case_id: 9,
//       case_name: "George",
//       page_count: 25,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-11T05:30:29",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//     {
//       case_id: 10,
//       case_name: "Chula Vis",
//       page_count: 15,
//       caseStatus: ["100%", "View report (5/5)"],
//       created_on: "2025-06-12T13:53:36",
//     },
//   ],
// };

const RecentUploads = ({handleShowUploads,handleContinueClick, recentCasesData}) => {
  const [searchTerm, setSearchTerm] = useState("");
   const caseData = {
    message: recentCasesData,
  };


  // Filtered list based on case_name matching searchTerm (case insensitive)
  const filteredCases = caseData?.message.sort((a, b) => new Date(b.created_on) - new Date(a.created_on)).filter((item) =>
    item.caseName?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

   const handleview = (item) => {
    //  if(item.caseStatus && item.caseStatus.length > 0 && item.caseStatus[0] == '100%'){
      localStorage.setItem("caseID", item.caseId);
      window.dispatchEvent(new Event("caseIDUpdated"));
      handleContinueClick();
   
    // }else{
    //   toast.error(`Sorry, this case is still processing. Please try again once it's completed.`);
    // }
  }

  


  return (
    // <div className="settings-page">
    //   <div className="topbar d-print-none">
    //     <div className="container px-2">
    //       <div className="main-wrapper">
    //         <SideBar/>
    <div
      id="div2"
      className="right-ctn flexible flex align-items-center h-100"
    >
      <div className="page-wrapper">
        {/* Page Content */}
        <div className="page-content d-flex flex-column w-100 align-items-center justify-content-start">
          {/* Upload main wrapper */}
          <div className="upload-wrapper-main container">
            {/* Upload header */}
            <div className="upload-header d-flex justify-content-between align-items-center mb-3">
              <h2 className="mb-0">Recent {localStorage.getItem('userdocumentlabel') 
                          ? `${localStorage.getItem('userdocumentlabel')}s` 
                          : 'Projects'}</h2>
              <button className="btn common-btn">
                <div
                  // to="/welcome"
                  onClick={handleShowUploads}
                  className="new-upload d-flex gap-2 align-items-center h-30 text-dark"
                >
                  <i
                    className="fa-solid fa-circle-plus"
                    data-bs-placement="right"
                    title="New Upload"
                  ></i>
                  <h4 className="text-disapper">New {localStorage.getItem('userdocumentlabel') 
                          ? `${localStorage.getItem('userdocumentlabel')}` 
                          : 'Project'}</h4>
                </div>
              </button>
            </div>
            {/* End upload header */}

            {/* File search input */}
            <div className="file-search">
              <div className="form-group search-input mb-2 d-flex align-items-center">
                <i className="icofont-search"></i>
                <input
                  type="text"
                  className="form-control"
                  id="search"
                  name="search"
                   placeholder={`Search ${localStorage.getItem('userdocumentlabel') 
                                  ? `${localStorage.getItem('userdocumentlabel')}s` 
                                  : 'Projects'}...`}
                  style={{ height: "40px" }}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            {/* End file search input */}

            {/* Uploaded files/documents */}
            <div className="d-flex flex-column gap-2 scrollable-container" >
              {filteredCases.length === 0 ? (
                <p>No matching files found.</p>
              ) : (
                filteredCases.map((item,index) => (
                  <div
                    key={index}
                    className="uploaded-document cursor-pointer d-flex align-items-center justify-content-between p-2 border rounded"
                    style={{ backgroundColor: "#f9f9f9" }}
                    onClick={()=> {handleview(item)}}
                  >
                    <div>
                      <h6 className="m-0 fs-14">{item.caseName || null}</h6>
                      <small className="text-secondary">
                        Pages: {item.casePageCount || 0} | Status: {item.caseStatus[0] || 0} |{" "}
                        {item.caseStatus[1] || null}
                      </small>
                    </div>
                    <div>
                      <small className="text-secondary">
                        {item.caseCreated}
                        {/* {new Date(item.created_on).toLocaleString()} */}
                      </small>
                    </div>
                  </div>
                ))
              )}
            </div>
            {/* End uploaded files/documents */}
          </div>
          {/* End upload main wrapper */}
        </div>
        {/* End page content */}
      </div>
    </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default RecentUploads;
